var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
            _c(
              "div",
              { staticClass: "flex items-center" },
              [
                _c("el-image", {
                  staticStyle: { width: "16px", height: "16px" },
                  attrs: { src: _vm.home },
                }),
                _c(
                  "span",
                  {
                    staticClass: "font-20 font-weight",
                    staticStyle: { "margin-left": "6px", "font-weight": "400" },
                    style: _vm.style ? "color: #FFFFFF" : "color:#666666",
                  },
                  [_vm._v(" " + _vm._s("首页 >") + " ")]
                ),
              ],
              1
            ),
          ]),
          _c("el-breadcrumb-item", [
            _c("div", { staticClass: "flex items-center" }, [
              _c(
                "span",
                {
                  staticClass: "font-20 font-weight",
                  staticStyle: { "margin-left": "6px", "font-weight": "400" },
                  style: _vm.style ? "color: #FFFFFF" : "color:#666666",
                },
                [_vm._v(" " + _vm._s(_vm.title) + " ")]
              ),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }